import React from 'react'
import './Service.css'


const Service = () => {
  return (
    <div className='container p-5 mt-5' id='Service'>
      <div className="top-content text-center">
      <h1 className='text-center'><span>Our</span> Services</h1>
      <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. </p></div>
      <div className="row text-center mt-5 top_row">
        <div className="col-md-4">
<img src="https://livewp.site/html/cryptolab/img/icons/icon-01.png"alt="" />
<p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Culpa ea ipsum voluptatum veniam eveniet vero? Molestias est pariatur consequatur tempore veritatis? Quod minus perferendis fugiat unde possimus ipsum atque accusantium.</p>
        </div>


        <div className="col-md-4">
<img src="https://livewp.site/html/cryptolab/img/icons/icon-02.png"alt="" />
<p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Culpa ea ipsum voluptatum veniam eveniet vero? Molestias est pariatur consequatur tempore veritatis? Quod minus perferendis fugiat unde possimus ipsum atque accusantium.</p>
        </div>



        <div className="col-md-4">
<img src="https://livewp.site/html/cryptolab/img/icons/icon-03.png" alt="" />
<p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Culpa ea ipsum voluptatum veniam eveniet vero? Molestias est pariatur consequatur tempore veritatis? Quod minus perferendis fugiat unde possimus ipsum atque accusantium.</p>
        </div>
      </div>

      {/* Second row */}
      
      <div className="row text-center mt-5 top_row">
        <div className="col-md-4">
<img src="https://livewp.site/html/cryptolab/img/icons/icon-04.png"alt="" />
<p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Culpa ea ipsum voluptatum veniam eveniet vero? Molestias est pariatur consequatur tempore veritatis? Quod minus perferendis fugiat unde possimus ipsum atque accusantium.</p>
        </div>


        <div className="col-md-4">
<img src="https://livewp.site/html/cryptolab/img/icons/icon-05.png"alt="" />
<p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Culpa ea ipsum voluptatum veniam eveniet vero? Molestias est pariatur consequatur tempore veritatis? Quod minus perferendis fugiat unde possimus ipsum atque accusantium.</p>
        </div>



        <div className="col-md-4">
<img src="https://livewp.site/html/cryptolab/img/icons/icon-06.png" alt="" />
<p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Culpa ea ipsum voluptatum veniam eveniet vero? Molestias est pariatur consequatur tempore veritatis? Quod minus perferendis fugiat unde possimus ipsum atque accusantium.</p>
        </div>
      </div>
      </div>
  )
}

export default Service